import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestLiteModel, GuestModel } from 'api-hooks/guest';
import { VisaDocumentLiteModel } from 'api-hooks/visa-document';
import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { PurchaseModel } from '../common/model';

export enum DocumentTypeEnum {
  visa = 'visa',
  passport = 'passport',
  insurance = 'insurance',
  apec_card = 'APEC',
}

//model
export class DocumentPurchaseLiteModel extends CommonModel {
  agent: string;
  description: string;
  number: string;

  @Type(() => Number)
  total: number;

  @Type(() => GuestLiteModel)
  guests: GuestLiteModel[];

  @Expose({ name: 'payment_channel' })
  paymentChannel: string;

  @Expose({ name: 'document_type' })
  documentType: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class DocumentPurchaseAddOnsModel {
  id: string;
  description: string;

  @Type(() => Number)
  price: number;

  @Type(() => GuestModel)
  guest: GuestModel;
}

export class DocumentPurchaseGuestPassportDetailModel {
  id: string;
  description: string;
  status: string;
  type: string;

  @Type(() => Number)
  price: number;
}
export class DocumentPurchaseGuestPassportModel {
  id: string;

  @Type(() => GuestModel)
  guest: GuestModel;

  @Type(() => DocumentPurchaseGuestPassportDetailModel)
  details: DocumentPurchaseGuestPassportDetailModel;
}

export class DocumentPurchaseGuestInsuranceDetailModel {
  id: string;
  company: string;
  description: string;
  package: string;
  status: string;
  type: string;

  @Expose({ name: 'cover_area' })
  coverArea: string;

  @Expose({ name: 'ended_at' })
  @Type(() => Date)
  endedAt: Date;

  @Expose({ name: 'started_at' })
  @Type(() => Date)
  startedAt: Date;

  @Type(() => Number)
  days: number;

  @Type(() => Number)
  price: number;
}

export class DocumentPurchaseGuestInsuranceModel {
  id: string;

  @Type(() => GuestModel)
  guest: GuestModel;

  @Type(() => DocumentPurchaseGuestInsuranceDetailModel)
  details: DocumentPurchaseGuestInsuranceDetailModel[];
}

export class PreferenceModel extends CommonModel {
  name: string;
}

export class DocumentPurchaseGuestVisaDetailModel {
  id: string;

  @Expose({ name: 'visa_document' })
  @Type(() => VisaDocumentLiteModel)
  visaDocument?: VisaDocumentLiteModel;

  biometric: boolean;
  description: string;

  @Type(() => Number)
  price: number;

  @Expose({ name: 'appointment_at' })
  @Type(() => Date)
  appointmentAt: Date;
}

export class DocumentPurchaseGuestVisaModel {
  id: string;

  @Type(() => GuestModel)
  guest: GuestModel;

  @Expose({ name: 'document_purchase_visa_guest_details' })
  @Type(() => DocumentPurchaseGuestVisaDetailModel)
  documentPurchaseVisaGuestDetails: DocumentPurchaseGuestVisaDetailModel[];
}

export class DocumentPurchasesModel {
  id: string;

  @Expose({ name: 'document_type' })
  documentType: string;

  @Expose({ name: 'document_purchase_add_ons' })
  @Type(() => DocumentPurchaseAddOnsModel)
  documentPurchaseAddOns: DocumentPurchaseAddOnsModel[];

  @Expose({ name: 'document_purchase_insurance_guests' })
  @Type(() => DocumentPurchaseGuestInsuranceModel)
  documentPurchaseInsuranceGuests: DocumentPurchaseGuestInsuranceModel[];

  @Expose({ name: 'document_purchase_passport_guests' })
  @Type(() => DocumentPurchaseGuestPassportModel)
  documentPurchasePassportGuests: DocumentPurchaseGuestPassportModel[];

  @Expose({ name: 'document_purchase_visa_guests' })
  @Type(() => DocumentPurchaseGuestVisaModel)
  documentPurchaseVisaGuests: DocumentPurchaseGuestVisaModel[];

  @Expose({ name: 'document_purchase_apec_card_guests' })
  @Type(() => DocumentPurchaseGuestPassportModel)
  documentPurchaseApecCardGuests: DocumentPurchaseGuestPassportModel[];

  @Expose({ name: 'visa_documents' })
  @Type(() => VisaDocumentLiteModel)
  visaDocuments?: VisaDocumentLiteModel[];
}

export class DocumentPurchaseModel extends PurchaseModel {
  @Expose({ name: 'document_purchases' })
  @Type(() => DocumentPurchasesModel)
  documentPurchases: DocumentPurchasesModel[];
}

export type DocumentPurchaseItemAddOnsMutationInput = {
  guestId: string;
  description: string;
  price: number;
};

export type DocumentPurchaseItemGuestDetaileMutationInput = {
  visaDocumentId: string;
  biometric: boolean;
  price: number;
  appointmentAt: Date | null;
  description: string;
  type: string;
  startedAt: Date | null;
  endedAt: Date | null;
  days: number;
  package: string;
  company: string;
  coverArea: string;
};

export type DocumentPurchaseItemGuestMutationInput = {
  guestId: string;
  details: DocumentPurchaseItemGuestDetaileMutationInput[];
};

export type DocumentPurchaseItemMutationInput = {
  documentType: string;
  visaDocuments: string[];
  documentPurchaseAddOns: DocumentPurchaseItemAddOnsMutationInput[];
  documentPurchaseGuests: DocumentPurchaseItemGuestMutationInput[];
};

// mutation
export type DocumentPurchaseMutationInput = {
  refId?: string;
  parentRefId?: string;
  code: string;
  description: string;
  type: string;
  transactionAt: Date;
  needApproval: boolean;
  tourRefId: string;
  invoiceRefId: string;
  agentId: string;
  paymentChannelId: string;
  discount: number;
  otherCost: number;
  total: number;
  documentPurchases: DocumentPurchaseItemMutationInput[];
};

export type DocumentPurchaseUpdateInput = {
  id: string;
  body: DocumentPurchaseMutationInput;
};

export type DocumentPurchaseVoidInput = {
  id: string;
};

//query

export type getDocumentPurchasesInput = {
  params: CommonParamInput;
};

export type getDocumentPurchaseInput = {
  id: string;
};
